<template>
  <div>
    <button @click="show = true">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 text-gray-600 inline-flex"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
        />
      </svg>
    </button>

    <Portal v-if="show" to="app-dialog">
      <PhoneNumbersPropertyEditModal
        :contact-id="contactId"
        :primary-phone-number="primaryPhoneNumber"
        :phone-numbers="phoneNumbers"
        :on-refresh-contact="fetchContact"
        @close="show = false"
      />
    </Portal>
  </div>
</template>

<script>
import PhoneNumbersPropertyEditModal from './PhoneNumbersPropertyEditModal.vue';

export default {
  components: {
    PhoneNumbersPropertyEditModal,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId] || null;
    },
    primaryPhoneNumber() {
      const primaryPhoneNumberId = this.contact?.primaryPhoneNumberId;
      if (!primaryPhoneNumberId) {
        return null;
      }

      return this.$store.state.entities.phoneNumbers.byId[primaryPhoneNumberId] || null;
    },
    phoneNumbers() {
      const phoneNumberIds = this.contact?.phoneNumbers;

      if (!phoneNumberIds) {
        return [];
      }

      return phoneNumberIds.map(
        (phoneNumberId) => this.$store.state.entities.phoneNumbers.byId[phoneNumberId]
      );
    },
  },
  inject: ['fetchContact'],
};
</script>
